import { useMemo, useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { verifyItems } from '@/mocks/home';

export default function VerifyChecklist() {
  const [checked, setChecked] = useState<string[]>([]);

  const toggle = (id: string) => {
    setChecked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const { done, percent, allDone } = useMemo(() => {
    const d = checked.length;
    const p = Math.round((d / verifyItems.length) * 100);
    return { done: d, percent: p, allDone: d === verifyItems.length };
  }, [checked]);

  return (
    <section id="verify" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <SectionHeading
              eyebrow="辨别真伪"
              title="逐项核对，判断是否为官方入口"
              desc="面对不熟悉的入口时，与其凭感觉判断，不如照单核对。下面六条覆盖了页面内容、来源与操作要求，逐项确认后基本可以判断入口是否可靠。"
            />

            <div className="mt-8 rounded-lg bg-background-100 border border-background-200/70 p-6">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-foreground-800">
                  已确认 {done} / {verifyItems.length} 项
                </span>
                <span className="font-heading text-lg font-bold text-primary-600">{percent}%</span>
              </div>
              <div className="mt-3 h-2 rounded-full bg-background-300 overflow-hidden">
                <div
                  className="h-full rounded-full bg-primary-500 transition-all duration-500"
                  style={{ width: `${percent}%` }}
                ></div>
              </div>
              <div
                className={`mt-4 flex items-start gap-2.5 rounded-md p-3.5 text-sm ${
                  allDone ? 'bg-primary-100 text-primary-900' : 'bg-secondary-50 text-secondary-900'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className={allDone ? 'ri-shield-check-line text-base' : 'ri-lightbulb-line text-base'}></i>
                </span>
                <p className="leading-relaxed">
                  {allDone
                    ? '六项均已确认，该入口在内容与操作要求上没有明显异常，可以正常使用。'
                    : '全部确认后即可获得更明确的判断结论。若出现未通过的项目，建议暂停使用并回到发布页核对。'}
                </p>
              </div>
            </div>
          </div>

          <ul className="flex flex-col gap-3">
            {verifyItems.map((item) => {
              const on = checked.includes(item.id);
              return (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-pressed={on}
                    className={`w-full flex items-start gap-3.5 text-left rounded-lg p-4 md:p-5 border transition-colors cursor-pointer ${
                      on ? 'bg-primary-50 border-primary-300' : 'bg-background-100 border-background-200/70 hover:border-primary-200'
                    }`}
                  >
                    <span
                      className={`mt-0.5 w-6 h-6 flex items-center justify-center rounded-md border shrink-0 transition-colors ${
                        on ? 'bg-primary-500 border-primary-500 text-background-50' : 'bg-background-50 border-background-300 text-transparent'
                      }`}
                    >
                      <i className="ri-check-line text-base"></i>
                    </span>
                    <span className={`text-sm md:text-base leading-relaxed ${on ? 'text-foreground-900' : 'text-foreground-700'}`}>
                      {item.label}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}